import React from 'react';
import HomeIcon from '../assets/icons/Home';
import CardsIcon from '../assets/icons/Cards';
import DocsIcon from '../assets/icons/Docs';
import TestAccountIcon from '../assets/icons/TestAccount';
import SupportIcon from '../assets/icons/Support';
import ProfileIcon from '../assets/icons/Profile';
import DesktopIcon from '../assets/icons/DesktopIcon';
import ReviewQueueIcon from '../assets/icons/ReviewQueueIcon';

export type MenuItem = {
  displayName: string;
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  link: string;
  onClick?: () => void;
};

export type AvailableRoles = 'Admin' | 'Manager' | 'Developer';

const developerMenuItems: MenuItem[] = [
  { displayName: 'Overview', Icon: HomeIcon, link: '/dashboard' },
  { displayName: 'Projects', Icon: CardsIcon, link: '/projects' },
  { displayName: 'Docs', Icon: DocsIcon, link: '/docs' },
  { displayName: 'Test Account', Icon: TestAccountIcon, link: '/test' },
  { displayName: 'Support', Icon: SupportIcon, link: '/support' },
];

const adminMenuItems: MenuItem[] = [
  { displayName: 'Overview', Icon: HomeIcon, link: '/admin' },
  { displayName: 'Review Queue', Icon: ReviewQueueIcon, link: '/admin/review-queue' },
  { displayName: 'Projects', Icon: CardsIcon, link: '/admin/projects' },
  { displayName: 'Developers', Icon: DesktopIcon, link: '/admin/developers' },
];

const managerMenuItems: MenuItem[] = [
  { displayName: 'Overview', Icon: HomeIcon, link: '/manager' },
  { displayName: 'Review Queue', Icon: ReviewQueueIcon, link: '/manager/review-queue' },
  { displayName: 'Projects', Icon: CardsIcon, link: '/manager/projects' },
];

export const menuItems: Record<AvailableRoles, MenuItem[]> = {
  Admin: adminMenuItems,
  Developer: developerMenuItems,
  Manager: managerMenuItems,
};

const developerSubMenuItems: MenuItem[] = [
  { displayName: 'Profile', Icon: ProfileIcon, link: '/profile' },
];

export const subMenuItems: Record<AvailableRoles, MenuItem[]> = {
  Admin: [],
  Developer: developerSubMenuItems,
  Manager: [],
};
